import { useCallback, useEffect, useState } from "react";
import { getMeetingWithTypes } from "../../../../services/StudentPortal/StudentAppointmentService";
import { handleApiError } from "../../../../utils/errorHandler";
import { unwrapList } from "../../utils/studentPortalUtils";

// Shares the same `parent.app.feature:appointment` gate as the appointment
// list itself (see useStudentAppointments.js) - an organization without the
// feature enabled can 403/404 this just as easily.
const isFeatureGated = (error) => {
  const status = error?.response?.status;
  return status === 403 || status === 404;
};

/**
 * Populates the "Meeting With" dropdown on the Book Appointment page.
 * Fetched once on mount - this list doesn't change within a session.
 */
export const useMeetingWithTypes = () => {
  const [types, setTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isFeatureUnavailable, setIsFeatureUnavailable] = useState(false);

  const fetchTypes = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await getMeetingWithTypes();
      setTypes(unwrapList(response));
      setIsFeatureUnavailable(false);
    } catch (error) {
      if (isFeatureGated(error)) {
        setIsFeatureUnavailable(true);
        setTypes([]);
      } else {
        handleApiError(error);
      }
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTypes();
  }, [fetchTypes]);

  return { types, isLoading, isFeatureUnavailable };
};

export default useMeetingWithTypes;
